import uniq from 'lodash/uniq';

import { LinkItem } from '@occc-app/design-system';

import { routeCreator } from './segments.router';

export const getBreadcrumbLinks = (segmentName: string | undefined): LinkItem[] => {
  return [
    {
      to: routeCreator.list(),
      label: 'Segments',
    },
    {
      key: routeCreator.details(segmentName ?? 'uuid'),
      label: segmentName || 'Loading...',
    },
  ];
};

export const extractMemberUuidsFromInputValue = (membersInputValue: string) => {
  const memberUuids = membersInputValue.split(',').map((uuid) => uuid.trim());
  return uniq(memberUuids);
};
